import { render, staticRenderFns } from "./ActorsHeader.vue?vue&type=template&id=1173d82e&scoped=true&"
import script from "./ActorsHeader.vue?vue&type=script&lang=js&"
export * from "./ActorsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActorsHeader.vue?vue&type=style&index=0&id=1173d82e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173d82e",
  null
  
)

export default component.exports